// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"dd89c289","436":"699994ef","453":"f394a27d","501":"07a98c49","606":"77e76cf2","821":"f93008df","925":"c856ccc7","969":"c24ca640"}[chunkId] + ".chunk.js";
};